// src/sagas/gallerySaga.js
import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import {
  FETCH_GALLERY_REQUEST,
  CREATE_ARTWORK_REQUEST,
  UPDATE_ARTWORK_REQUEST,
  DELETE_ARTWORK_REQUEST,
} from "../actions/types";
import {
  fetchGallerySuccess,
  fetchGalleryFailure,
  createArtworkSuccess,
  createArtworkFailure,
  updateArtworkSuccess,
  updateArtworkFailure,
  deleteArtworkSuccess,
  deleteArtworkFailure,
} from "../actions/galleryActions";
import {
  saveLibraryCardToApi,
  deleteLibraryCardFromApi,
} from "../apis/libraryCardApi";
import { fetchPublicGallery } from "../apis/publicApi";
import { v4 as uuidv4 } from "uuid";
import { getTenantId, getOwnerTenantId } from "../utils/authUtils";

function* fetchGallerySaga(action) {
  try {
    const tenantId = action.payload?.tenantId || getOwnerTenantId();
    const cards = yield call(fetchPublicGallery, { tenantId });
    const artworks = cards.map((card) => ({
      ...card,
      ...(typeof card.payload === "string" ? JSON.parse(card.payload) : card.payload),
    }));
    yield put(fetchGallerySuccess(artworks));
  } catch (err) {
    console.error("gallerySaga - fetchGallery error:", err);
    yield put(fetchGalleryFailure(err.message));
  }
}

function* createArtworkSaga(action) {
  try {
    const tenantId = getTenantId();
    const entityId = uuidv4();
    const input = {
      tenantId,
      entityType: "ARTWORK",
      entityId,
      payload: JSON.stringify({ entityId, ...action.payload }), // create payload is already clean
    };
    const result = yield call(saveLibraryCardToApi, input);
    if (!result?.success) throw new Error(result?.message || "Save failed");
    yield put(createArtworkSuccess({ entityId, entityType: "ARTWORK", tenantId, ...action.payload }));
  } catch (err) {
    console.error("gallerySaga - createArtwork error:", err);
    yield put(createArtworkFailure(err.message));
  }
}

function* updateArtworkSaga(action) {
  try {
    const tenantId = getTenantId();
    // Strip card-level fields so they don't pollute the payload JSON
    const { entityId, entityType: _et, tenantId: _t, payload: _p, createdAt: _c, ...artworkData } = action.payload;
    const input = {
      tenantId,
      entityType: "ARTWORK",
      entityId,
      payload: JSON.stringify({ entityId, ...artworkData }),
    };
    const result = yield call(saveLibraryCardToApi, input);
    if (!result?.success) throw new Error(result?.message || "Save failed");
    yield put(updateArtworkSuccess(action.payload));
  } catch (err) {
    console.error("gallerySaga - updateArtwork error:", err);
    yield put(updateArtworkFailure(err.message));
  }
}

function* deleteArtworkSaga(action) {
  try {
    const tenantId = getTenantId();
    const { entityId } = action.payload;
    yield call(deleteLibraryCardFromApi, { tenantId, entityType: "ARTWORK", entityId });
    yield put(deleteArtworkSuccess(entityId));
  } catch (err) {
    console.error("gallerySaga - deleteArtwork error:", err);
    yield put(deleteArtworkFailure(err.message));
  }
}

export default function* gallerySaga() {
  yield takeLatest(FETCH_GALLERY_REQUEST, fetchGallerySaga);
  yield takeLatest(CREATE_ARTWORK_REQUEST, createArtworkSaga);
  yield takeEvery(UPDATE_ARTWORK_REQUEST, updateArtworkSaga);
  yield takeEvery(DELETE_ARTWORK_REQUEST, deleteArtworkSaga);
}
